module.exports = "/assets/dist/images/shield.svg?b61278f4c64b1a06e81202953050657e";